import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  SelectProps,
  useTheme,
} from "@mui/material";
import { FieldPath, FieldValues, useController } from "react-hook-form";
import { RhfInputProps } from "../RhfInputProps";
import { selectDefaultProps } from "../selectDefaultProps";
import { emptyMenuItem } from "../SelectDefaultComponents";
import { LocationTypeForSelect } from "./LocationTypeForSelect";

type Props = {
  onLocationTypeChanged: () => void;
  locationTypes: LocationTypeForSelect[];
  label?: string;
};

export const LocationTypeSelect = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
  name,
  control,
  onLocationTypeChanged,
  disabled,
  locationTypes,
  label = "Location Type",
  ...selectProps
}: RhfInputProps<TFieldValues, TName> & Props & SelectProps) => {
  const theme = useTheme();

  const {
    field,
    fieldState: { error },
    formState: { disabled: isFormDisabled },
  } = useController({
    control,
    name,
  });

  return (
    <FormControl fullWidth size="small" disabled={isFormDisabled || disabled}>
      <InputLabel id="destinationType-label" shrink>
        {label}
      </InputLabel>
      <Select
        {...selectDefaultProps}
        {...selectProps}
        {...field}
        labelId="destinationType-label"
        label={label}
        notched
        onChange={(event) => {
          onLocationTypeChanged();
          field.onChange(event);
        }}
        disabled={disabled}
      >
        {emptyMenuItem(-1)}
        {locationTypes.map((type) => (
          <MenuItem key={type.Id} value={type.Id}>
            {type.LocationType}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText
        sx={{
          color: theme.palette.error.main,
          position: "absolute",
          bottom: "-1.5rem",
        }}
      >
        {error?.message}
      </FormHelperText>
    </FormControl>
  );
};
